import type { IconDef } from '../types';

export const growth: IconDef = {
  viewBox: '0 0 24 24',
  paths: [
    {
      d: 'M23.0211 4.34714L14.9916 4.0007C14.4312 3.98032 13.9523 4.40829 13.9319 4.97891C13.9115 5.53934 14.3395 6.01826 14.9101 6.03864L20.3208 6.273L13.2492 13.3447L9.80505 9.90054C9.40765 9.50314 8.7657 9.50314 8.3683 9.90054L0.298049 17.9708C-0.0993496 18.3682 -0.0993496 19.0101 0.298049 19.4075C0.501843 19.6113 0.756585 19.703 1.02152 19.703C1.28645 19.703 1.54119 19.6011 1.74499 19.4075L9.09176 12.0608L12.5359 15.5049C12.9333 15.9023 13.5752 15.9023 13.9726 15.5049L21.8391 7.63842C21.8391 7.63842 21.8595 7.60785 21.8697 7.59766L21.6149 13.365C21.5945 13.9255 22.0225 14.4044 22.5931 14.4248C22.6033 14.4248 22.6237 14.4248 22.6339 14.4248C23.1739 14.4248 23.6223 13.9968 23.6529 13.4466L23.9993 5.41707C24.0197 4.85663 23.5917 4.37772 23.0211 4.35734V4.34714Z',
    },
  ],
};
